import __request__ from "routing/request";
export function getOutdatedIndices(requestOptions) {
  return __request__("GET", "/system/indexer/indices/outdated", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDeleteOutdated(Entitiestoremove, requestOptions) {
  return __request__("POST", "/system/indexer/indices/outdated/bulk_delete", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkReindex(indices, requestOptions) {
  return __request__("POST", "/system/indexer/indices/outdated/bulkreindex", indices, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listOutdatedIndices(sort = "index_name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/system/indexer/indices/outdated/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteOutdated(index, requestOptions) {
  return __request__("DELETE", `/system/indexer/indices/outdated/${index}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function reindex(index, withReplication = true, requestOptions) {
  return __request__("POST", `/system/indexer/indices/outdated/${index}/reindex`, null, { "withReplication": withReplication }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
